module.exports = __webpack_public_path__ + "static/media/giftsSent_2000_3000.8ea59a4d.png";